import React from "react";
import "./style.css";

export default function index() {
  return (
    <div className="footer-container">
      Already taken this assessment? Invite others to generate a Blueprint to
      Unlocking their iSavant instead.
      <span className="color-pink"> Click here</span>
    </div>
  );
}
